import { AuxiliumComponent } from "../auxilium-component";

export class ChipOption extends AuxiliumComponent {
	constructor() {
		super();

		this.value = this.getAttribute("value") ?? "";
	}
}